import TagManager from 'react-gtm-module';
import { GOOGLE_TAG_MANAGER_ID } from 'src/appConfig';

declare global {
  interface Window {
    dataLayer: any;
  }
}
export const tagManagerEvent = (eventName, email = null) => {
  const tagManagerArgs = {
    gtmId: GOOGLE_TAG_MANAGER_ID
  };

  TagManager.initialize(tagManagerArgs);
  try {
    window.dataLayer.push({
      event: eventName,
      'user-email': email
    });
  } catch (e) {
    console.log('error', e);
  }
};

export const tagManagerLoginEvent = (eventName: String, autoLogin: Boolean) => {
  const tagManagerArgs = {
    gtmId: GOOGLE_TAG_MANAGER_ID
  };

  TagManager.initialize(tagManagerArgs);
  try {
    window.dataLayer.push({
      event: eventName,
      auto_logged_in: autoLogin
    });
  } catch (e) {
    console.log('error', e);
  }
};

export const tagManagerEventWithSource = (eventName, payload) => {
  const tagManagerArgs = {
    gtmId: GOOGLE_TAG_MANAGER_ID
  };

  TagManager.initialize(tagManagerArgs);
  try {
    window.dataLayer.push({
      event: eventName,
      'user-email': payload?.email,
      signup_source: payload?.signup_source
    });
  } catch (e) {
    console.log('error', e);
  }
};

export const tagManagerPurchaseEvent = (eventName, eventData = null) => {
  const tagManagerArgs = {
    gtmId: GOOGLE_TAG_MANAGER_ID
  };

  TagManager.initialize(tagManagerArgs);
  try {
    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: eventName,
      ecommerce: eventData
    });
  } catch (e) {
    console.log('error', e);
  }
};
